import { useEffect, useState } from "react";
import { GetShopBasketOrder } from "../utils/api";
import { api } from "ticketino-api-client";

export function useOrder(baseUrl) {
    const [order, setOrder] = useState({});
    const [regularToken, setRegularToken] = useState(null);

    useEffect(() => {
        setRegularToken(localStorage.getItem("token"));
    }, []);

    useEffect(() => {
        const initializeOrder = async () => {
            let orderIdFromSession = localStorage.getItem("OrderId");
            if (orderIdFromSession && regularToken) {
                try {
                    let orderResponse = await fetchOrderById(orderIdFromSession);
                    if (orderResponse && orderResponse.id) {
                        setOrder(orderResponse);
                        return;
                    }
                } catch (error) {
                    console.error('Error fetching order by Id:', error);
                }
            }
        };
        initializeOrder();
    }, [regularToken, baseUrl]);

    const fetchOrderById = async (orderId) => {
        try {
            if (!regularToken) {
                throw new Error("No regularToken found at fetchOrderById");
            }
            api.defaults.baseURL = baseUrl;
            const res = await GetShopBasketOrder(baseUrl, "token", regularToken, orderId);
            return res;
        } catch (error) {
            localStorage.removeItem("OrderId");
            console.error('Error fetching order by Id:', error);
        }
    };

    return order;
}
